import { Box, Flex, Group, Stack, Text, UnstyledButton } from "@mantine/core";
import { useState } from "react";

import type { SalesGuidanceItem, SalesGuidanceMetadata } from "../../../shared-types/types";

export function SalesGuidanceHeader({ title }: { title: string }) {
    return (
        <Group
            bg="linear-gradient(90deg, #29446C 0%, #5C3D4E 100%)"
            gap="xs"
            p="sm"
            styles={{ root: { borderTopLeftRadius: "1.25rem", borderTopRightRadius: "1.25rem" } }}
        >
            <Text size="sm" fw={600}>
                {title}
            </Text>
        </Group>
    );
}

export function SalesGuidance({ metadata }: { metadata: SalesGuidanceMetadata }) {
    return (
        <Stack gap="sm">
            {metadata.items.map((item, i) => (
                <SalesGuidanceItemView key={i} item={item} />
            ))}
        </Stack>
    );
}

function SalesGuidanceItemView({ item }: { item: SalesGuidanceItem }) {
    return (
        <Stack gap={4}>
            <Text size="sm" fw={600} pb={"xs"}>
                {item.phrase}
            </Text>
            {item.subheading && (
                <Text size="xs" c="dark.2" pb={"xs"}>
                    {item.subheading}
                </Text>
            )}
            {item.examples && item.examples.length > 0 && <ExampleCarousel examples={item.examples} />}
        </Stack>
    );
}

function ExampleCarousel({ examples }: { examples: string[] }) {
    const [index, setIndex] = useState(0);
    const safeIndex = index >= examples.length ? examples.length - 1 : index;

    return (
        <Stack gap={0}>
            <Flex align="center" justify="start" pb={2}>
                <UnstyledButton
                    px={"xxs"}
                    c="dark.2"
                    onClick={() => setIndex(wrapIndex(safeIndex - 1, examples.length))}
                    aria-label="Previous example"
                >
                    <Text size="xs">‹</Text>
                </UnstyledButton>
                <Text size="xs" ta="end">
                    {safeIndex + 1} of {examples.length}
                </Text>
                <UnstyledButton
                    px={"xxs"}
                    c="dark.2"
                    onClick={() => setIndex(wrapIndex(safeIndex + 1, examples.length))}
                    aria-label="Next example"
                >
                    <Text size="xs">›</Text>
                </UnstyledButton>
            </Flex>

            <Box bg="#333f4880" px={"xxs"}>
                <Text size="xs" lh="sm">
                    {examples[safeIndex]}
                </Text>
            </Box>
        </Stack>
    );
}

function wrapIndex(index: number, length: number): number {
    return ((index % length) + length) % length;
}
